<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,4C15,4,1,4,1,4C0.45,4,0,4.45,0,5C0,5,0,11,0,11C0,11.55,0.45,12,1,12C1,12,15,12,15,12C15.55,12,16,11.55,16,11C16,11,16,5,16,5C16,4.45,15.55,4,15,4C15,4,15,4,15,4ZM14,10C14,10,8,10,8,10C8,10,8,6,8,6C8,6,14,6,14,6C14,6,14,10,14,10C14,10,14,10,14,10Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SegmentedControl',
} as DefineComponent
</script>
